import { render, staticRenderFns } from "./GiubileoSchedaEditComponent.vue?vue&type=template&id=668b94b3"
import script from "./GiubileoSchedaEditComponent.vue?vue&type=script&lang=js"
export * from "./GiubileoSchedaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports